import React from 'react';


function PlainTextCell(props) {
    const id = props.cellContent[props.cellData.id]
    return (
        <div title={props.cellContent[props.cellData.show]} id={id} key={id}
             className='row__cell'>{props.cellContent[props.cellData.show]}</div>
    );
}

export default PlainTextCell;
